import { useContext, useState } from 'react';
import { UserUpdate, WP_HouseRef, WP_HouseTerm } from '../../../model/models';
import { AppContext } from '../../../state/AppContextProvider';
import { chevronDownOutline, chevronUpOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import { UpdateUserFunc } from '../../../hooks/WPHooks';
import { FormattedMessage } from 'react-intl';
import { ModelsService } from '../../../services/ModelsService';
import { HouseImgIcon } from '../../house/HouseImgIcon';

interface SwitchHousesProps {
  houses: Array<WP_HouseRef>;
  update: UpdateUserFunc;
}

const HouseIcon = ({ houseTerm }) => {
  const houseThumbnail = ModelsService.getHouseThumbnail(houseTerm);
  return houseThumbnail ? (
    <img
      src={houseThumbnail}
      alt={'Chargement impossible'}
      className="rounded-full w-10 h-10"
    />
  ) : (
    <HouseImgIcon className="w-10 h-10 text-primary" />
  );
};

export const SwitchHouses: React.FC<SwitchHousesProps> = ({
  houses,
  update,
}: SwitchHousesProps) => {
  const { state } = useContext(AppContext);

  const [showHouses, setShowHouses] = useState<boolean>(false);

  const housesRefToHousesTax = (): Array<WP_HouseTerm | null> => {
    let ret: Array<WP_HouseTerm | null> = [];
    ret = houses
      .map((house) => {
        const houseTerm = state.allHouses.find((h) => h.id === house.term_id);
        if (houseTerm) {
          return houseTerm;
        } else {
          return null;
        }
      })
      .filter((house) => house !== null);

    return ret;
  };

  const housesTerm: Array<WP_HouseTerm | null> = housesRefToHousesTax();

  const changeCurrentHouse = (currentHouseId: number) => {
    const userHousesInOrder: Array<number> = houses
      .map((house: WP_HouseRef) => house.term_id)
      .sort((houseA: number, houseB: number) => {
        if (houseA === currentHouseId) {
          return -1;
        } else if (houseB === currentHouseId) {
          return 1;
        } else {
          return 0;
        }
      });

    const dataToUpdate: UserUpdate = {
      acf: {
        user_house: userHousesInOrder,
      },
    };

    update(dataToUpdate);
    setShowHouses(false);
  };

  return (
    <div className="border-2 rounded-xl border-primary border-opacity-40">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setShowHouses(!showHouses)}
      >
        {housesTerm[0] && (
          <div className="p-4 flex flex-row justify-start items-center">
            <HouseIcon houseTerm={housesTerm[0]} />
            <div className="flex flex-col justify-start items-start pl-2">
              <label className="font-bold text-sm"> {housesTerm[0].name}</label>
              <p className="text-xs text-black opacity-50">
                <FormattedMessage id="Current house" />
              </p>
            </div>
          </div>
        )}
        <IonIcon
          className="mr-4"
          icon={showHouses ? chevronUpOutline : chevronDownOutline}
        />
      </div>
      <div className={` ${!showHouses && 'hidden'}`}>
        {housesTerm.map((house, index) => {
          if (house !== null) {
            return (
              <div
                key={'house_' + index}
                className={`px-4 flex flex-row justify-start items-center hover:bg-gray-100 cursor-pointer ${
                  index === housesTerm.length - 1 && 'rounded-b-xl'
                }`}
                onClick={() => changeCurrentHouse(house.id)}
              >
                <div
                  className={`w-full py-2 flex justify-start items-center ${
                    index === 0 && 'border-t border-gray-200'
                  }`}
                >
                  <HouseIcon houseTerm={house} />
                  <div className="flex flex-col justify-start items-start pl-2">
                    <label className="text-gray-500 text-sm">
                      {house.name}
                    </label>
                  </div>
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};
